<template>
    <CopyButton @click="copyShareUrl" />
</template>

<script setup>

import copy from "clipboard-copy";
import CopyButton from "@/components/shopopee/button/copyButton.vue";
import util from "@/util/util";
import {inject} from "vue";

const props = defineProps(["url", "useAlert"])

const i18n = inject("i18n")

function copyShareUrl(){
    if (null != props.url){
        copy(props.url)

        if (false !== props.useAlert){
            util.alertSuccess(i18n.tkey("lang_copy_success"))
        }
    }

}

</script>

<style scoped>

</style>